import { ErrorBoundary } from 'react-error-boundary';
import { useContext, useState } from 'react';
import LoggerContext from '../../context/LoggerContext';
import ErrorModal from '../ErrorModal/ErrorModal';

const ErrorBoundaryComponent = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
    const logger = useContext(LoggerContext);
    const [, setErrorMessage] = useState('');

    const logError = (error: Error): void => {
        setErrorMessage(error.message);
        logger.error(error);
        console.log(error);
    };

    const handleResetError = (): void => {
        console.log('Error boundary reset');
        setErrorMessage('');
    };

    return (
        <ErrorBoundary
            onError={logError}
            onReset={handleResetError}
            FallbackComponent={() => {
                return <ErrorModal retry={handleResetError} />;
            }}
        >
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryComponent;
